import React from 'react';
import { motion } from 'framer-motion';
export function Roadmap() {
  return <section className="py-24 border-b border-stone-300" data-id="element-1156">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1157">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1158">
          <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1159">
            Roadmap
          </p>

          <h2 className="font-serif text-4xl md:text-5xl tracking-tight leading-[1.1] text-stone-900 mb-6 max-w-3xl" data-id="element-1160">
            From instant quotes to industry intelligence
          </h2>

          <p className="text-lg text-stone-600 leading-relaxed mb-16 max-w-2xl" data-id="element-1161">
            Own the pipe, own the data. BlockQuote builds the infrastructure
            today to power the intelligence layer of tomorrow.
          </p>

          {/* Timeline */}
          <div className="border border-stone-300" data-id="element-1162">
            <div className="grid grid-cols-1 md:grid-cols-4" data-id="element-1163">
              {/* MVP */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300 bg-stone-100" data-id="element-1164">
                <div className="flex items-center justify-between mb-4" data-id="element-1165">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-900 font-medium" data-id="element-1166">
                    MVP
                  </p>
                  <p className="font-mono text-xs text-red-600" data-id="element-1167">Now</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1168">
                  Instant Infrastructure
                </p>
                <p className="text-sm text-stone-600" data-id="element-1169">
                  Quotes, holds, proposals, basic workflow
                </p>
              </div>

              {/* V1 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1170">
                <div className="flex items-center justify-between mb-4" data-id="element-1171">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1172">
                    V1
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1173">Q2 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1174">
                  Closing the Loop
                </p>
                <p className="text-sm text-stone-600" data-id="element-1175">
                  Contracts, e-sign, payments, PMS integrations
                </p>
              </div>

              {/* V2 */}
              <div className="p-6 border-b md:border-b-0 md:border-r border-stone-300" data-id="element-1176">
                <div className="flex items-center justify-between mb-4" data-id="element-1177">
                  <p className="font-mono text-xs uppercase tracking-widest text-stone-500" data-id="element-1178">
                    V2
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1179">Q4 2026</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1180">Intelligence</p>
                <p className="text-sm text-stone-600" data-id="element-1181">
                  Benchmarking, probability scoring, forecasting
                </p>
              </div>

              {/* V3 */}
              <div className="p-6 border-l-2 border-l-red-600 md:border-l-0 md:border-t-2 md:border-t-red-600" data-id="element-1182">
                <div className="flex items-center justify-between mb-4" data-id="element-1183">
                  <p className="font-mono text-xs uppercase tracking-widest text-red-600 font-medium" data-id="element-1184">
                    V3
                  </p>
                  <p className="font-mono text-xs text-stone-400" data-id="element-1185">2027</p>
                </div>
                <p className="font-medium text-stone-900 mb-2" data-id="element-1186">Rate Brain</p>
                <p className="text-sm text-stone-600" data-id="element-1187">
                  Aggregation + intelligence platform
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}